/**
 * Include your custom JavaScript here.
 *
 * We also offer some hooks so you can plug your own logic. For instance, if you want to be notified when the variant
 * changes on product page, you can attach a listener to the document:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   var variant = event.detail.variant; // Gives you access to the whole variant details
 * });
 *
 * You can also add a listener whenever a product is added to the cart:
 *
 * document.addEventListener('product:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 *   var quantity = event.detail.quantity; // Get the quantity that was added
 * });
 *
 * If you just want to force refresh the mini-cart without adding a specific product, you can trigger the event
 * "cart:refresh" in a similar way (in that case, passing the quantity is not necessary):
 *
 * document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
 *   bubbles: true
 * }));
 */
jQuery(document).ready(function() {
  if($('.ProductListWrapper').length > 0){
    // setTimeout(function(){
    //   $('.ProductListWrapper .ProductItem__PriceList').each(function(){
    //     var change_price = $(this).find('.regular-price').find('.pre-money').text();
    //     var vip_price = change_price.match(/[0-9.]+/g);
    //     $(this).find('.vip_price').find('span.ProductItem__Price').text('$' + (vip_price[0]/2).toFixed(2));
    //   })
    // }, 300);
    var timer = setInterval(function() {
      if ($(".ProductListWrapper .Grid__Cell .regular-price .money").length > 0) {
        clearInterval(timer);
        $('.ProductListWrapper .ProductItem__PriceList').each(function(){          
          var change_price = $(this).find('.regular-price').find('.money').text();
          var vip_price = change_price.match(/[0-9.]+/g);
          if(vip_price[0]){
            if($(this).attr('data-vip') != '1'){
              $(this).find('.vip_price').find('span.ProductItem__Price').text('$' + (vip_price[0]/2).toFixed(2));
            }else{
              $(this).find('.vip_price').find('span.ProductItem__Price').text('$' + (vip_price[0]/1).toFixed(2));              
              $(this).find('.regular-price').find('.regular-price-origin').html('$' + (parseFloat(vip_price[0])*2).toFixed(2));
              $(this).find('.regular-price').find('.money').css('display', 'none');
            }
          }
        })
      }
    }, 100)

    $('.custom-ATC select').on('change', function() {      
        var price_container = $(this).parents('.custom-ATC').siblings('.ProductItem');
        change_price = price_container.find('.regular-price').find('.money').text();
        vip_price = change_price.match(/[0-9.]+/g);
        if(vip_price[0]){
          if(price_container.find('.ProductItem__PriceList').attr('data-vip') != '1'){
            price_container.find('.vip_price').find('span.ProductItem__Price').text('$' + (vip_price[0]/2).toFixed(2));
            price_container.find('.regular-price').find('.regular-price-origin').text('$' + vip_price[0]);
          }else{
            price_container.find('.vip_price').find('span.ProductItem__Price').text('$' + (vip_price[0]/1).toFixed(2));
            price_container.find('.regular-price').find('.regular-price-origin').text('$' + (parseFloat(vip_price[0])*2).toFixed(2));
          }          
        }
        
    });
  }
});
$(window).on('load', function() {
  setTimeout(function(){
    jQuery(".ProductMeta__Price.money").each(function() {
      if(jQuery(this).parent().parent().find('.member-only').text() != jQuery(this).text()) {
        jQuery(this).css('color', '#F94C43');
        jQuery(this).parent().parent().find('.member-only').css('display', 'inline-block');
        jQuery(this).parent().parent().find('.vip-price').css('display', 'inline-block');
      }
    });
    jQuery(".ProductItem__PriceList .money").each(function() {
      if(jQuery(this).parent().parent().find('.member-only').text() != jQuery(this).text()) {
        jQuery(this).css('color', '#F94C43');
        jQuery(this).parent().parent().find('.member-only').css('display', 'inline-block');
        jQuery(this).parent().parent().find('.vip-price').css('display', 'inline-block');
      }
    });
  }, 1000);
});